var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-breadcrumb',{attrs:{"align":"is-centered"}},[_c('b-breadcrumb-item',{attrs:{"tag":"router-link","to":"/"}},[_vm._v("ConsultaCEP")]),_c('b-breadcrumb-item',{attrs:{"tag":"router-link","to":"/sobre"}},[_vm._v("SOBRE")])],1),_c('section',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }